module.exports = __webpack_public_path__ + "img/public/SiteIcons/speedometerIcon.svg?46a005ee";